import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_203_6162)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_203_6162",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 25,
			children: /* @__PURE__ */ _jsx("rect", {
				y: .218994,
				width: 24,
				height: 24,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_203_6162)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M4.50777 18.919C4.05761 18.919 3.67711 18.7635 3.36627 18.4525C3.05544 18.1415 2.90002 17.7608 2.90002 17.3103V7.11979C2.90002 6.66929 3.05544 6.28988 3.36627 5.98154C3.67711 5.67321 4.05761 5.51904 4.50777 5.51904H19.4923C19.9424 5.51904 20.3229 5.67454 20.6338 5.98554C20.9446 6.29654 21.1 6.67729 21.1 7.12779V17.3183C21.1 17.7688 20.9446 18.1482 20.6338 18.4565C20.3229 18.7649 19.9424 18.919 19.4923 18.919H4.50777ZM12 12.9768L4.20002 8.38629V17.3113C4.20002 17.4011 4.22886 17.4749 4.28652 17.5325C4.34419 17.5902 4.41794 17.619 4.50777 17.619H19.4923C19.5821 17.619 19.6559 17.5902 19.7135 17.5325C19.7712 17.4749 19.8 17.4011 19.8 17.3113V8.38629L12 12.9768ZM12 11.294L19.6463 6.81904H4.35377L12 11.294ZM4.20002 8.38629V6.81904V17.3113C4.20002 17.4011 4.22886 17.4749 4.28652 17.5325C4.34419 17.5902 4.41794 17.619 4.50777 17.619H4.20002V8.38629Z",
				fill: "currentColor"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_203_6162",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor",
			transform: "translate(0 0.218994)"
		})
	}) })]
});
export default SvgMessage;
